import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import NoteBox from 'Components/common/NoteBox';
import SmartText from '@reuters-graphics/react-smart-text';
import last from 'lodash/last';
import { roundDownSmart } from 'Utils/roundDown';

const atlas = new AtlasMetadataClient();

const Text = (props) => {
  const { vaccinationData } = props;

  const content = useContext(ContentContext);
  const countrySlug = useContext(CountryContext);
  const locale = useContext(LocaleContext);

  if (!vaccinationData) return null;

  const country = atlas.getCountry(countrySlug);

  const population = country.dataProfile.population.d;
  const totalNeeded = population * 2;
  const latestData = last(vaccinationData.totalDoses);
  const latestTotal = latestData.count;
  const weekAgo = new Date(latestData.date);
  weekAgo.setDate(weekAgo.getDate() - 7);

  const popPercent = Math.round((latestTotal / totalNeeded) * 100 * 10) / 10;

  return (
    <>
      <SmartText
        source={popPercent < 0.1 ? content.template.vaccination.introLess : content.template.vaccination.intro}
        context={{
          country: atlas.getCountry(countrySlug).translations[locale],
          administered: latestTotal.toLocaleString(locale),
          popPercent: popPercent.toLocaleString(locale),
        }}
        wrap
      />
    </>
  );
};

export default Text;
